import * as React from "react";
import { IInputFieldProps, FieldSchema, CollapseMode } from "@generation/core";
import { useCollapseContext } from "../Context/Collapse/CollapseContext";

export function withCollapseFieldHoc<T extends IInputFieldProps<FieldSchema>>(
  Component: React.ComponentType<T>
) {
  const component = (props: T) => {
    const collapseContext = useCollapseContext();

    const collapseGroupId = props.field.ui?.readOverview?.collapse?.groupId;
    const isShowing = collapseGroupId && collapseContext.state.has(collapseGroupId);
    if (props.field.ui?.readOverview?.collapse?.mode === CollapseMode.Target && !isShowing) {
      return null;
    }
    return <Component {...props} />;
  };

  component.displayName = "withCollapseFieldHoc";

  return component;
}
